module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "right",
      "font-size": "11px"
    }
  }, [(_vm.loading == false) ? _c('span', [_vm._v("\n        Son Güncelleme: " + _vm._s(_vm.lastUpdate) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('span', [_vm._v("\n        Yeni veriler yükleniyor...\n    ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-62f33f3d!./~/vue-loader/lib/selector.js?type=template&index=0!./public/src/components/auto_update.vue
// module id = 373
// module chunks = 0